import { render } from "./WhSelect.vue?vue&type=template&id=63159e1e"
import script from "./WhSelect.vue?vue&type=script&lang=js"
export * from "./WhSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__